var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1736493813664,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2325,
    "data-spm-anchor-id": "a313x.search_index.0.i12.48a63a81Mu8mwa",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 512m-506.88 0a506.88 506.88 0 1 0 1013.76 0 506.88 506.88 0 1 0-1013.76 0Z",
    fill: "#7a294f",
    "p-id": 2326,
    "data-spm-anchor-id": "a313x.search_index.0.i9.48a63a81Mu8mwa",
    className: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 1024C230.4 1024 0 793.6 0 512S230.4 0 512 0s512 230.4 512 512-230.4 512-512 512zM512 12.8C235.52 12.8 12.8 235.52 12.8 512S235.52 1011.2 512 1011.2 1011.2 788.48 1011.2 512 788.48 12.8 512 12.8z",
    fill: "#7a294f",
    "p-id": 2327,
    "data-spm-anchor-id": "a313x.search_index.0.i13.48a63a81Mu8mwa",
    className: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M742.4 281.6H281.6v460.8h460.8V281.6z",
    fill: "#7a294f",
    fillOpacity: 0.01,
    "p-id": 2328,
    "data-spm-anchor-id": "a313x.search_index.0.i4.48a63a81Mu8mwa",
    className: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M719.36 496.64l-51.2-51.2v-69.12c0-10.24-10.24-20.48-20.48-20.48h-69.12l-51.2-51.2c-7.68-7.68-20.48-7.68-28.16 0l-51.2 51.2h-69.12c-10.24 0-20.48 10.24-20.48 20.48v69.12l-51.2 51.2c-7.68 7.68-7.68 20.48 0 28.16l51.2 51.2v69.12c0 10.24 10.24 20.48 20.48 20.48h69.12l51.2 51.2c5.12 5.12 10.24 5.12 15.36 5.12s10.24-2.56 15.36-5.12l51.2-51.2h69.12c10.24 0 20.48-10.24 20.48-20.48v-69.12l51.2-51.2c5.12-5.12 5.12-20.48-2.56-28.16z m-87.04 58.88c-5.12 2.56-5.12 10.24-5.12 15.36v56.32h-56.32c-5.12 0-10.24 2.56-15.36 5.12L512 675.84l-43.52-43.52c-5.12-5.12-10.24-5.12-15.36-5.12h-56.32v-56.32c0-5.12-2.56-10.24-5.12-15.36L348.16 512l43.52-43.52c2.56-5.12 5.12-10.24 5.12-15.36v-56.32h56.32c5.12 0 10.24-2.56 15.36-5.12l43.52-43.52 43.52 43.52c2.56 2.56 10.24 5.12 15.36 5.12h56.32v56.32c0 5.12 2.56 10.24 5.12 15.36l43.52 43.52-43.52 43.52z",
    fill: "#ffffff",
    "p-id": 2329,
    "data-spm-anchor-id": "a313x.search_index.0.i6.48a63a81Mu8mwa",
    className: "selected"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512 435.2c-43.52 0-76.8 35.84-76.8 76.8s35.84 76.8 76.8 76.8 76.8-35.84 76.8-76.8-33.28-76.8-76.8-76.8z m0 115.2c-20.48 0-38.4-17.92-38.4-38.4s17.92-38.4 38.4-38.4 38.4 17.92 38.4 38.4-17.92 38.4-38.4 38.4z",
    fill: "#ffffff",
    "p-id": 2330,
    "data-spm-anchor-id": "a313x.search_index.0.i7.48a63a81Mu8mwa",
    className: "selected"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/system.7498a6cfb3f55727d3c268555faa7427.svg";
export { ForwardRef as ReactComponent };